import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { Form } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import Layout from '../../components/Layout/Layout.js';
import ReturnItem from '../../components/ReturnItem/ReturnItem.js';
import { useReturnItemsForm } from '../../hooks/use-return-items-form.js';

const SelectItemsPage = ({ email , orderNumber , lineItems , returnReasons  })=>{
    const { getLabel  } = useIntl();
    const [{ isAnyCheckboxChecked , submitForm  }, { loading , formState  }] = useReturnItemsForm({
        email,
        orderNumber,
        lineItems
    });
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(Heading, {
        component: "h1",
        variant: "small"
    }, lineItems && (lineItems === null || lineItems === void 0 ? void 0 : lineItems.length) > 1 ? getLabel('returns.page.selectItems.title') : getLabel('returns.page.selectItems.title.singular')), /*#__PURE__*/ React.createElement(Form, {
        name: "returns-request-form",
        showErrorsOnInvalidSubmit: false,
        initialFormState: formState,
        onSubmit: submitForm
    }, lineItems === null || lineItems === void 0 ? void 0 : lineItems.map((lineItem, index)=>/*#__PURE__*/ React.createElement(ReturnItem, {
            key: `item-${index}`,
            item: lineItem,
            id: `${index}`,
            required: !isAnyCheckboxChecked(formState),
            isOnlyItem: lineItems.length === 1,
            returnReasons: returnReasons
        })
    ), /*#__PURE__*/ React.createElement(Button, {
        className: "select-items-page__button",
        caption: getLabel('returns.page.selectItems.submit'),
        isLoading: loading,
        disabled: loading,
        type: "submit"
    })));
};
var SelectItemsPage$1 = SelectItemsPage;

export { SelectItemsPage$1 as default };
//# sourceMappingURL=SelectItemsPage.js.map
